/** Chunk install-command strings into copyable groups (joined with newlines). */
export const INSTALL_COMMAND_GROUP_SIZE = 4;

export const groupInstallCommands = (
  commands: string[],
  groupSize: number = INSTALL_COMMAND_GROUP_SIZE
): string[] => {
  if (!commands.length || groupSize < 1) return [];

  const groups: string[] = [];
  for (let i = 0; i < commands.length; i += groupSize) {
    const chunk = commands
      .slice(i, i + groupSize)
      .map((cmd) => cmd.trim())
      .filter(Boolean);
    if (chunk.length > 0) groups.push(chunk.join('\n'));
  }
  return groups;
};

export const getInstallCommandGroupTitle = (
  groupIndex: number,
  groupCount: number
): string => {
  if (groupCount <= 1 || groupIndex === 0) {
    return 'Run the following commands to download and install the agent:';
  }
  if (groupIndex === groupCount - 1) {
    return 'Complete the installation with the following commands:';
  }
  return 'Continue with the following commands:';
};
